import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7058db79")

_pushScopeId("data-v-7058db79")
const _hoisted_1 = {
  class: "modal fade",
  id: "modal_price_group_assignment",
  tabindex: -1,
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-800px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_price_group_assignment_header"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "btn btn-sm btn-icon",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-1" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_6 = { class: "modal-body pt-10 pb-5 px-lg-17" }
const _hoisted_7 = { class: "scroll-y me-n7 pe-7" }
const _hoisted_8 = { class: "row mb-8" }
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_13 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_14 = { class: "row mb-8" }
const _hoisted_15 = { class: "col-12 text-end" }
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus me-2" }, null, -1)
const _hoisted_17 = {
  key: 1,
  class: "d-flex justify-content-end gap-2"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "fas fa-save me-2" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times me-2" }, null, -1)
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-12" }
const _hoisted_22 = { class: "card" }
const _hoisted_23 = { class: "card-header d-flex justify-content-between align-items-center" }
const _hoisted_24 = { class: "card-title" }
const _hoisted_25 = /*#__PURE__*/_createVNode("i", { class: "fas fa-sync-alt me-1" }, null, -1)
const _hoisted_26 = { class: "card-body" }
const _hoisted_27 = {
  key: 0,
  class: "text-center py-10"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("i", { class: "fas fa-list-ul fs-3x text-muted mb-5" }, null, -1)
const _hoisted_29 = { class: "text-muted" }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { class: "table-responsive" }
const _hoisted_32 = { class: "table table-striped" }
const _hoisted_33 = { class: "text-end" }
const _hoisted_34 = { class: "text-end" }
const _hoisted_35 = /*#__PURE__*/_createVNode("i", { class: "fas fa-edit" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash" }, null, -1)
const _hoisted_37 = { class: "modal-footer flex-center" }
const _hoisted_38 = {
  type: "reset",
  class: "btn btn-white me-3",
  "data-bs-dismiss": "modal"
}
const _hoisted_39 = { class: "indicator-label" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Select = _resolveComponent("Select")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, {
      loading: _ctx.loading,
      innerLoading: true
    }, null, 8, ["loading"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          model: _ctx.assignmentData,
          ref: "assignmentForm",
          key: _ctx.formKey
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_4, [
              _createVNode("h2", null, _toDisplayString(_ctx.$t('message.PRICE_GROUP_ASSIGNMENT')), 1),
              _hoisted_5
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _createVNode("div", _hoisted_9, [
                    _createVNode(_component_Select, {
                      ref: "priceGroupSelectRef",
                      name: "price_group",
                      target: "priceGroup",
                      label: _ctx.$t('message.PRICE_GROUP'),
                      placeholder: _ctx.$t('message.SELECT_PRICE_GROUP'),
                      priceGroup: _ctx.assignmentData.price_group,
                      "onUpdate:priceGroup": _cache[1] || (_cache[1] = ($event: any) => (_ctx.assignmentData.price_group = $event)),
                      selectData: _ctx.availablePriceGroups,
                      value: _ctx.assignmentData.price_group,
                      searchable: true,
                      filterable: true,
                      key: `price-group-${_ctx.formKey}`
                    }, null, 8, ["label", "placeholder", "priceGroup", "selectData", "value"])
                  ]),
                  _createVNode("div", _hoisted_10, [
                    _createVNode(_component_Select, {
                      ref: "discountTypeSelectRef",
                      name: "discount_type",
                      target: "discountType",
                      label: _ctx.$t('message.DISCOUNT_TYPE'),
                      placeholder: _ctx.$t('message.SELECT_DISCOUNT_TYPE'),
                      discountType: _ctx.assignmentData.discount_type,
                      "onUpdate:discountType": _cache[2] || (_cache[2] = ($event: any) => (_ctx.assignmentData.discount_type = $event)),
                      selectData: _ctx.discountTypes,
                      value: _ctx.assignmentData.discount_type,
                      key: `discount-type-${_ctx.formKey}`
                    }, null, 8, ["label", "placeholder", "discountType", "selectData", "value"])
                  ]),
                  _createVNode("div", _hoisted_11, [
                    _createVNode("div", _hoisted_12, [
                      _createVNode("label", _hoisted_13, [
                        _createVNode("span", null, _toDisplayString(_ctx.$t('message.DISCOUNT_VALUE')), 1)
                      ]),
                      _withDirectives((_openBlock(), _createBlock("input", {
                        type: "number",
                        step: "0.01",
                        class: "form-control",
                        placeholder: _ctx.$t('message.ENTER_DISCOUNT_VALUE'),
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.assignmentData.discount_value = $event)),
                        key: `discount-value-${_ctx.formKey}`
                      }, null, 8, ["placeholder"])), [
                        [_vModelText, _ctx.assignmentData.discount_value]
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_14, [
                  _createVNode("div", _hoisted_15, [
                    (!_ctx.isEditing)
                      ? (_openBlock(), _createBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn btn-custom",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addAssignment && _ctx.addAssignment(...args))),
                          disabled: !_ctx.canAddAssignment
                        }, [
                          _hoisted_16,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('message.ADD_ASSIGNMENT')), 1)
                        ], 8, ["disabled"]))
                      : (_openBlock(), _createBlock("div", _hoisted_17, [
                          _createVNode("button", {
                            type: "button",
                            class: "btn btn-custom",
                            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.updateAssignment && _ctx.updateAssignment(...args))),
                            disabled: !_ctx.canAddAssignment
                          }, [
                            _hoisted_18,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('message.UPDATE_ASSIGNMENT')), 1)
                          ], 8, ["disabled"]),
                          _createVNode("button", {
                            type: "button",
                            class: "btn btn-secondary",
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args)))
                          }, [
                            _hoisted_19,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('message.CANCEL')), 1)
                          ])
                        ]))
                  ])
                ]),
                _createVNode("div", _hoisted_20, [
                  _createVNode("div", _hoisted_21, [
                    _createVNode("div", _hoisted_22, [
                      _createVNode("div", _hoisted_23, [
                        _createVNode("h3", _hoisted_24, _toDisplayString(_ctx.$t('message.ASSIGNMENT_LIST')), 1),
                        _createVNode("button", {
                          type: "button",
                          class: "btn btn-sm btn-light",
                          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.refreshAssignments && _ctx.refreshAssignments(...args))),
                          disabled: _ctx.loading
                        }, [
                          _hoisted_25,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('message.REFRESH')), 1)
                        ], 8, ["disabled"])
                      ]),
                      _createVNode("div", _hoisted_26, [
                        (_ctx.assignmentList.length === 0)
                          ? (_openBlock(), _createBlock("div", _hoisted_27, [
                              _hoisted_28,
                              _createVNode("p", _hoisted_29, _toDisplayString(_ctx.$t('message.NO_ASSIGNMENTS_YET')), 1)
                            ]))
                          : (_openBlock(), _createBlock("div", _hoisted_30, [
                              _createVNode("div", _hoisted_31, [
                                _createVNode("table", _hoisted_32, [
                                  _createVNode("thead", null, [
                                    _createVNode("tr", null, [
                                      _createVNode("th", null, _toDisplayString(_ctx.$t('message.ID')), 1),
                                      _createVNode("th", null, _toDisplayString(_ctx.$t('message.PRICE_GROUP')), 1),
                                      _createVNode("th", null, _toDisplayString(_ctx.$t('message.DISCOUNT_TYPE')), 1),
                                      _createVNode("th", null, _toDisplayString(_ctx.$t('message.DISCOUNT_VALUE')), 1),
                                      _createVNode("th", _hoisted_33, _toDisplayString(_ctx.$t('message.ACTIONS')), 1)
                                    ])
                                  ]),
                                  _createVNode("tbody", null, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.assignmentList, (assignment, index) => {
                                      return (_openBlock(), _createBlock("tr", {
                                        key: assignment.id || index
                                      }, [
                                        _createVNode("td", null, _toDisplayString(assignment.id || '-'), 1),
                                        _createVNode("td", null, _toDisplayString(assignment.price_group_name || _ctx.getPriceGroupName(assignment.price_group)), 1),
                                        _createVNode("td", null, _toDisplayString(_ctx.getDiscountTypeName(assignment.discount_type)), 1),
                                        _createVNode("td", null, _toDisplayString(assignment.discount_value), 1),
                                        _createVNode("td", _hoisted_34, [
                                          (assignment.id)
                                            ? (_openBlock(), _createBlock("button", {
                                                key: 0,
                                                type: "button",
                                                class: "btn btn-sm btn-primary me-1",
                                                onClick: ($event: any) => (_ctx.editAssignment(assignment, index))
                                              }, [
                                                _hoisted_35
                                              ], 8, ["onClick"]))
                                            : _createCommentVNode("", true),
                                          _createVNode("button", {
                                            type: "button",
                                            class: "btn btn-sm btn-danger",
                                            onClick: ($event: any) => (_ctx.removeAssignment(index))
                                          }, [
                                            _hoisted_36
                                          ], 8, ["onClick"])
                                        ])
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ])
                            ]))
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_37, [
              _createVNode("button", _hoisted_38, _toDisplayString(_ctx.$t('message.CANCEL')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn btn-custom",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.submitHandlerForm()))
              }, [
                _createVNode("span", _hoisted_39, _toDisplayString(_ctx.$t('message.SUBMIT')), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ])
  ]))
})